
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import React, { useEffect } from 'react';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link,useNavigate } from "react-router-dom";
import PureCounter from "@srexi/purecounterjs";

const Home = () => {

  useEffect(() => {
    // Initialize AOS (Animate On Scroll)
    AOS.init();

    // Initialize Swiper
    const swiper = new Swiper('.review-swiper', {
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 3 },
        480: { slidesPerView: 1 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },
    });

    // Initialize PureCounter
    new PureCounter({
      selector: '.purecounter',
      start: 0,
      end: 500,
      duration: 1,
      delay: 10,
      once: true,
      pulse: false,
      decimals: 0,
      legacy: true,
      filesizing: false,
      currency: false,
      formater: 'us-US',
      separator: false,
    });

    // Handle Scroll Event for Navbar Shadow
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (window.scrollY > 50) {
        navbar.classList.add('shadow');
      } else {
        navbar.classList.remove('shadow');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      swiper.destroy();
    };
  }, []);

  return (
    <div >
   <Navbar/>


   <div
      class="container-fluid position-relative half-fluid cloudmins-container"
    >
      <div class="container">
        <div class="row" id="introContainer">
          {/* <!-- Text --> */}
          <div
            class="col-lg-6 py-5 pe-lg-5 pe-5 d-flex justify-content-center flex-column introContent"
          >
            <h1 class="fw-900">
              Enterprise Web & Mobile App Development Company
            </h1>
            <p class="fw-500">
              Top Enterprise Web & Mobile App Development Company. Boost your
              business with our expert solutions. Contact us for innovative web
              and mobile apps.
            </p>
            {/* <!-- <div>We have deliverd for</div> --> */}
          </div>

          {/* <!-- Image --> */}
          <div class="col-lg-6 position-lg-absolute right-half h-100">
            <div class="image">
              <img src="/images/cloude_mines_main_bg.svg" />
            </div>
          </div>
        </div>
        {/* <!-- <div id="wrap">
          <ul id="slider1">
            <li class="slide-item"><img src="/images/adityabirla.png" class="serveCompanyLogo"></li>
            <li class="slide-item"><img src="/images/airasia.png" class="serveCompanyLogo"></li>
            <li class="slide-item"><img src="/images/amazon.png" class="serveCompanyLogo"></li>
            <li class="slide-item"><img src="/images/decathlon.png" class="serveCompanyLogo"></li>
            <li class="slide-item"><img src="/images/toyota.png" class="serveCompanyLogo"></li>            
          </ul>
        </div>    --> */}
        <div id="services" data-aos="fade-up" class="my-5">
          <div class="position-relative z-index-10">
            <div class="index-heading">Our Services</div>
            <div></div>
          </div>
          <div class="row position-relative z-index-10 d-flex align-items-center">
            <div class="col-lg-6 py-3 pe-lg-5 servicesHeading">
              <h1 class="fw-900">Enterprise Application</h1>
              <h1 class="fw-900">Development</h1>
            </div>
            <div class="col-lg-6 py-3 position-lg-absolute right-half h-100">
              <div class="servicesContent">
                Let's kick-start your digital transformation journey to evolve
                rapidly and transform seamlessly.
              </div>
              <div class="cloudmins-btn sevicesBtn">Veiw All Services</div>
            </div>
          </div>
          <div class="row servicesContainer" data-aos="fade-up">
            <div class="container custom-container">
              <h1 class="custom-title">Web App Development</h1>
              <p class="custom-text">
                Develop innovative and next-generation web applications with our
                custom web app development service.
              </p>
              <button class="btn btn-primary">Click Me</button>
            </div>
            <div class="container custom-container">
              <h1 class="custom-title">Gaming Development</h1>
              <p class="custom-text">
                We develop games for mobile, NFT, metaverse, PC, and web
                platforms. Our game developers are experienced in cutting-edge
                game engines such as Unity and Unreal.
              </p>
              <button class="btn btn-primary">Click Me</button>
            </div>
            <div class="container custom-container">
              <h1 class="custom-title">Mobile App Development</h1>
              <p class="custom-text">
                We develop cross-platform mobile apps integrating the latest
                technologies like Cloud, AI/ML, AR/VR, etc., with a stunning
                UI/UX design.
              </p>
              <button class="btn btn-primary">Click Me</button>
            </div>
          </div>
          <div class="row servicesContainer" data-aos="fade-up">
            <div class="container custom-container">
              <h1 class="custom-title">UI/UX Designing</h1>
              <p class="custom-text">
                A clear and effective design process will help you build the
                product you need on time. Zethic provides intuitive designs and
                outstanding user experience.
              </p>
              <button class="btn btn-primary">Click Me</button>
            </div>
            <div class="container custom-container">
              <h1 class="custom-title">AI/ML development</h1>
              <p class="custom-text">
                In order to deliver immersive customer experiences and satisfy
                next-generation users, we build AR/VR apps that put an
                unbelievable twist on mundane processes.
              </p>
              <button class="btn btn-primary">Click Me</button>
            </div>
            <div class="container custom-container">
              <h1 class="custom-title">3D Modeling Designing</h1>
              <p class="custom-text">
                Designing in 3D is the process of creating a digital model of an
                object. Zethic's 3D modelers can produce industrial designs,
                concept models, high-poly and low-poly models, as well as 3D
                models with textures.
              </p>
              <button class="btn btn-primary">Click Me</button>
            </div>
          </div>
        </div>
        <div id="technologies" data-aos="fade-up" class="my-5">
          <div>
            <div class="index-heading">Our Technology Stack</div>
            <div></div>
          </div>
          <div class="row">
            <div class="col-lg-6 py-3 pe-lg-5 technologyHeading">
              <h1 class="fw-900">Find the Best Technology for</h1>
              <h1 class="fw-900">Your Product</h1>
            </div>
            <div class="col-lg-6 py-3 position-lg-absolute right-half h-100">
              <div class="technologyContent">
                Our expertise spans over innovative technologies and platforms,
                enabling us to deliver customized business solutions.
              </div>
            </div>
            <div id="marquee1">
              <div class="marquee__group1">
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/android.svg"
                    alt="First slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/flutter.svg"
                    alt="Second slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/laravel.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/node.png"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/javascript.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/postgress.png"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/typescript.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/vue.png"
                    alt="Third slide"
                  />
                </div>
              </div>
              <div class="marquee__group1">
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/android.svg"
                    alt="First slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/flutter.svg"
                    alt="Second slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/laravel.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/node.png"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/javascript.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/postgress.png"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/typescript.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/vue.png"
                    alt="Third slide"
                  />
                </div>
              </div>
            </div>
            <div id="marquee">
              <div class="marquee__group">
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/mysql.svg"
                    alt="First slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/tailwind.svg"
                    alt="Second slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/scss.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/react.webp"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/python.jpg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/nextjs.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/mongodb.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/bootstarp.png"
                    alt="Third slide"
                  />
                </div>
              </div>
              <div class="marquee__group" aria-hidden="true">
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/mysql.svg"
                    alt="First slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/tailwind.svg"
                    alt="Second slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/scss.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/react.webp"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/python.jpg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/nextjs.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/mongodb.svg"
                    alt="Third slide"
                  />
                </div>
                <div class="imageSlider d-block">
                  <img
                    class="d-block"
                    src="/images/bootstarp.png"
                    alt="Third slide"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="industries" data-aos="fade-up">
          <div>
            <div class="index-heading">Industry We Serve</div>
            <div></div>
          </div>
          <div class="row">
            <div class="col-lg-6 py-3 pe-lg-5 industryHeading">
              <h1 class="fw-900">Industries We Serve</h1>
            </div>
            <div class="col-lg-6 py-3 position-lg-absolute right-half h-100 industryContent">
              <div class="industryContent">
                We provide solutions for a variety of industries, from Logistics
                to Healthcare and many more, that improve business performance
                and increase return on investment.
              </div>
            </div>
          </div>
          <div class="review-slider">
            <div class="swiper review-swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide review-card">FinTech</div>
                <div class="swiper-slide review-card">EdTech</div>
                <div class="swiper-slide review-card">Healthcare</div>
                <div class="swiper-slide review-card">Hospitality</div>
                <div class="swiper-slide review-card">Logistics</div>
                <div class="swiper-slide review-card">Retail & E-commerce</div>
                <div class="swiper-slide review-card">Travel</div>
                <div class="swiper-slide review-card">Entertainment</div>
                <div class="swiper-slide review-card">SocialMedia</div>
              </div>
              {/* <!-- Pagination dots --> */}
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>

        <div class="aboutus-section" id="aboutus">
          <div>
            <div class="index-heading">About Us</div>
            <div></div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12" data-aos="fade-right">
                <div class="aboutus">
                  <p class="aboutus-text">
                  We are driven by innovation, efficiency, and cutting-edge technology.we empower businesses to streamline operations, enhance security, and achieve digital transformation.

                  </p>
                  <p class="aboutus-text">
                  We don’t just provide technology—we create smart, future-ready solutions that drive success. Partner with us and experience the power of intelligent solutions today.

                  </p>
                  <a class="cloudmins-btn aboutusBtn" href="./aboutus.html">Read More</a>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12 aboutusContent" data-aos="fade-left">
                <div class="feature">
                  <div class="feature-box">
                    <div class="clearfix">
                      <div class="iconset">
                        <span class="fas fa-heart icon"></span>
                      </div>
                      <div class="feature-content">
                        <h4>Work with heart</h4>
                        <p>
                        Innovation is fueled by passion, dedication, and excellence. Working with heart is our core philosophy—we prioritize customers, crafting seamless, secure, and smart solutions that drive success. With integrity, creativity, and quality, we build trust, foster strong relationships, and exceed expectations. We don’t just work—we put our heart into every solution we create.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="feature-box">
                    <div class="clearfix">
                      <div class="iconset">
                        <span class="fab fa-servicestack icon"></span>
                      </div>
                      <div class="feature-content">
                        <h4>Reliable services</h4>
                        <p>
                        Reliability is our foundation. We deliver seamless, secure, and high-performance solutions, ensuring smooth operations without disruptions. With consistent, scalable, and proactive support, we prioritize quality, security, and customer satisfaction. When you partner with us , you’re choosing a team that stands for trust, stability, and long-term success.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="feature-box">
                    <div class="clearfix">
                      <div class="iconset">
                        <span class="far fa-envelope icon"></span>
                      </div>
                      <div class="feature-content">
                        <h4>Great support</h4>
                        <p>
                        We believe that exceptional service goes beyond technology—it’s about unwavering support. Our dedicated team is always ready to assist, providing proactive, responsive, and personalized solutions to keep your business running smoothly. With 24/7 assistance, expert guidance, and a customer-first approach, we ensure that every challenge is met with efficiency and care.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
     

   
   </div>

  )
}

export default Home